export default __webpack_public_path__ + "static/media/management-team.681f491f.svg";